import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1D472295-8F79-4F51-B68A-63A2CD2DF634
 * name playlist-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-minus.svg
 * tags
 */
export const PlaylistMinusIcon = createSvgIcon(<><path d="M3 16H10V14H3M12 14V16H22V14M14 6H3V8H14M14 10H3V12H14V10Z" /></>, 'PlaylistMinusIcon');
export default PlaylistMinusIcon